import { ContentGroup, contentGroupVariants } from '@/shared/ui'
import type { CatalogComponentEntry } from './component-registry.types'

const renderContentGroupSample = (label: string) => (
  <>
    <p className="text-xs uppercase tracking-wide text-muted-foreground">{label}</p>
    <div className="h-2 w-24 rounded bg-muted/60" />
    <div className="h-2 w-32 rounded bg-muted/60" />
  </>
)

const formatContentGroupSummary = (variantId: keyof typeof contentGroupVariants) => {
  const variant = contentGroupVariants[variantId]
  return `Tokens: surface=${variant.surface}, padding=${variant.padding}, radius=${variant.radius}, gap=${variant.gap}, border=${variant.border}, blur=${variant.blur}, align=${variant.align}, justify=${variant.justify}`
}

export const contentGroupEntries: CatalogComponentEntry[] = [
  {
    name: 'Content Group / registrationDesktop',
    path: 'shared/ui/content-group',
    layer: 'shared',
    description: `Figma: 69:479 (desktop registration). ${formatContentGroupSummary('registrationDesktop')}`,
    component: ContentGroup,
    render: () => (
      <ContentGroup variant="registrationDesktop">
        {renderContentGroupSample('Registration')}
      </ContentGroup>
    ),
  },
  {
    name: 'Content Group / registrationMobile',
    path: 'shared/ui/content-group',
    layer: 'shared',
    description: `Figma: 177:6594 (mobile registration). ${formatContentGroupSummary('registrationMobile')}`,
    component: ContentGroup,
    render: () => (
      <ContentGroup variant="registrationMobile">
        {renderContentGroupSample('Registration')}
      </ContentGroup>
    ),
  },
  {
    name: 'Content Group / registrationMobileB2B',
    path: 'shared/ui/content-group',
    layer: 'shared',
    description: `Figma: 179:7681 (mobile registration B2B). ${formatContentGroupSummary('registrationMobileB2B')}`,
    component: ContentGroup,
    render: () => (
      <ContentGroup variant="registrationMobileB2B">
        {renderContentGroupSample('Registration B2B')}
      </ContentGroup>
    ),
  },
  {
    name: 'Content Group / planSelectorDesktop',
    path: 'shared/ui/content-group',
    layer: 'shared',
    description: `Figma: 80:956 (plan selector desktop). ${formatContentGroupSummary('planSelectorDesktop')}`,
    component: ContentGroup,
    render: () => (
      <ContentGroup variant="planSelectorDesktop">
        {renderContentGroupSample('Plan selector')}
      </ContentGroup>
    ),
  },
  {
    name: 'Content Group / planSelectorMobile',
    path: 'shared/ui/content-group',
    layer: 'shared',
    description: `Figma: 216:5098 (plan selector mobile). ${formatContentGroupSummary('planSelectorMobile')}`,
    component: ContentGroup,
    render: () => (
      <ContentGroup variant="planSelectorMobile">
        {renderContentGroupSample('Plan selector')}
      </ContentGroup>
    ),
  },
  {
    name: 'Content Group / contentDesktop',
    path: 'shared/ui/content-group',
    layer: 'shared',
    description: `Figma: 80:1044 (desktop content group). ${formatContentGroupSummary('contentDesktop')}`,
    component: ContentGroup,
    render: () => (
      <ContentGroup variant="contentDesktop">{renderContentGroupSample('Content')}</ContentGroup>
    ),
  },
  {
    name: 'Content Group / contentMobile',
    path: 'shared/ui/content-group',
    layer: 'shared',
    description: `Figma: 216:5205 (mobile content group). ${formatContentGroupSummary('contentMobile')}`,
    component: ContentGroup,
    render: () => (
      <ContentGroup variant="contentMobile">{renderContentGroupSample('Content')}</ContentGroup>
    ),
  },
  {
    name: 'Content Group / transparentPanel',
    path: 'shared/ui/content-group',
    layer: 'shared',
    description: `Figma: 143:2413 + 219:3432 (transparent panel). ${formatContentGroupSummary('transparentPanel')}`,
    component: ContentGroup,
    render: () => (
      <ContentGroup variant="transparentPanel">
        {renderContentGroupSample('Transparent panel')}
      </ContentGroup>
    ),
  },
  {
    name: 'Content Group / transparentPanelMobile',
    path: 'shared/ui/content-group',
    layer: 'shared',
    description: `Figma: 219:3432 (mobile transparent panel). ${formatContentGroupSummary('transparentPanelMobile')}`,
    component: ContentGroup,
    render: () => (
      <ContentGroup variant="transparentPanelMobile">
        {renderContentGroupSample('Transparent panel mobile')}
      </ContentGroup>
    ),
  },
  {
    name: 'Content Group / infoPanelMobile',
    path: 'shared/ui/content-group',
    layer: 'shared',
    description: `Figma: 215:4259 (mobile information panel). ${formatContentGroupSummary('infoPanelMobile')}`,
    component: ContentGroup,
    render: () => (
      <ContentGroup variant="infoPanelMobile">
        {renderContentGroupSample('Info panel')}
      </ContentGroup>
    ),
  },
  {
    name: 'Content Group / borderBackgroundPanel',
    path: 'shared/ui/content-group',
    layer: 'shared',
    description: `Figma: 1460:3652 (bordered glass panel). ${formatContentGroupSummary('borderBackgroundPanel')}`,
    component: ContentGroup,
    render: () => (
      <ContentGroup variant="borderBackgroundPanel">
        {renderContentGroupSample('Border background panel')}
      </ContentGroup>
    ),
  },
]
